// main
import { useHistory } from "react-router-dom";

import ContentFormatXZ from "../content/webc/content-format-xz";

import WebbDividerMedium from "../content/webb/webb-divider-md";
import WebbDividerSmall from "../content/webb/webb-divider-sm";

import { ethers } from "ethers";

export default function Main () {
  
  const history = useHistory();
  const provider = new ethers.providers.Web3Provider(window.ethereum, "any")

  const handleAuth = async () => {

    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    const acnt = await signer.getAddress();

    const auth = await signer.signMessage("Login to RENTSE");

    if (auth) alert ('auth-ok')
    else alert('auth-no')

    console.log ('signer:', signer)
    console.log ('acnt:', acnt)
    console.log ('auth: ', auth)

  }

  const handleDemo = async(memo) => {
    console.log (memo)

    const acnt = await provider.send("eth_requestAccounts", []);
    
    const signer = provider.getSigner(acnt[0])
    const acbl = await provider.getBalance(acnt[0])

    if (acnt) {
      console.log (acnt[0])
      console.log (signer)
      console.log ('acbl:', ethers.utils.formatEther(acbl))

      const tx = await signer.sendTransaction({
        to: "0x9C2d9A698CF59810119eD00D96644f0248B9416D",
        value: ethers.utils.parseEther("0.000001")
      });
      console.log (tx)
    } 
    else console.log ('acnt-no')
  }



  if (window.ethereum) console.log('meta-ok')
  else console.log ('meta-no')

  return(
    <>
      <ContentFormatXZ 
        head='Main'
        link={``}
        form= 'mini'
        data= {
          <>
            <WebbDividerMedium />
            <WebbDividerMedium />
            <div className="bg-white rounded-wd text-center">
              <WebbDividerSmall />
              <WebbDividerMedium />
              
              <i className='bx bx-home-alt text-color-main' style={{fontSize:'3.3rem'}}></i>
              <WebbDividerMedium />

              <h1 className="fw-bold text-color-main" style={{fontSize:'1.9rem'}}>
                {process.env.REACT_APP_WEBB_SITE_NAME}
              </h1>
              <p className="lead text-color-tone">
                {process.env.REACT_APP_WEBB_SITE_LINE}
              </p>

              <div className="" style={{height:'15vh'}}></div>
              <p>Coming Soon</p>
              <WebbDividerMedium />
            </div>
            <WebbDividerSmall />
            
            <div className="p-3 bg-wite hilite text-center rounded-wd"
              style={{cursor:'pointer'}}
              onClick={() => handleAuth('Metamask')}
            
            >Metamask Auth</div>
            
            <WebbDividerMedium />
          </>
        } 
      />
    </>
  )
}